(function (module) {
    "use strict";
    module.filter('percentage', ['$filter', function ($filter: ng.IFilterService) {
        return function (input: $TSFixMe, decimals: $TSFixMe, mult: $TSFixMe) {
            if (input == null)
                return '';
            if (!mult) {
                mult = 1;
            }
            return $filter('number')(input * mult, decimals) + '%';
        };
    }]);

})(angular.module('topline.filters'));